import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CustomersService } from '../rest_services/customers.service';
import { DashboardService } from '../rest_services/dashboard.service';
import { VisitService } from '../rest_services/visit.service';
import { VisitsService } from '../rest_services/visits.service';
import { MsSectorService } from '../rest_services/ms-sector.service';
import { UserService } from '../rest_services/user.service';

@Component({
  selector: 'app-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.css']
})
export class ActionsComponent implements OnInit, OnDestroy {

  loading_actions:boolean=true;
  action:any;
  advancedSearchForm: FormGroup;
  role:any;
  selectedAction:any ={};
  updateActionForm!: FormGroup;
  loading_actions_search: boolean = false;
  constructor(
    private visitServiceservice:VisitsService, 
    private visitService:VisitService,
    private dashboardService:DashboardService, 
    private customersService :CustomersService,
    private msSector : MsSectorService,
    private userService:UserService,
    private fb:FormBuilder
    ) {
      this.advancedSearchForm = this.fb.group({
        'customer': [''],
        'commercial' : [''] ,
        'customer_sector' : [''] ,
        'visit_topic' : [''] ,
        'customer_city' : [''],
        'action_type' : [''],
        'action_status' : [''],
        'visit_action_status' : [''],
        'start_date':[''],
        'end_date':[''],
        'archived':[false]
      }); 
      this.updateActionForm = this.fb.group({
        description:['', [Validators.required]],
        status:['', [Validators.required]],
        motif:['', [Validators.required]]
      });
    }
  
  mobile:boolean=false;
  token!: string;
  msToken!: any;
  uuid!: string;
  user:any;
  ngOnInit(): void {
    this.msToken = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");
    this.getAllCustomers();
    this.getCommercials();
    this.getSectors();
    this.Topic();
    this.getCities(); 
    this.token = this.dashboardService.token;
    let decodedJWT = JSON.parse(window.atob(this.token.split('.')[1]));
    this.uuid = decodedJWT.userId;
    this.indicatorsActionsPlan(this.uuid);
    if(localStorage.getItem("role")!=undefined) {
      this.role =localStorage.getItem("role");
    }else if(sessionStorage.getItem("role")!=undefined){
      this.role =sessionStorage.getItem("role");
    }
    this.userService.userSubject.subscribe(
      (data)=>{
        if(data.code =="f99fc2d2a6c1e8eb12bd88d1b0d05d26"){
          this.user = data.connected_user;
        }
      }
    );
    this.Actions();
    // this.getAllCustomers();
    // this.getCommercials();
    // this.getSectors();
    // this.Topic();
    if (window.screen.width < 768) { // 768px portrait
      this.mobile = true;
    }else {
      this.mobile = false;
    }
  }
  indicators:any;
  loadingIndicatorsPlan:boolean=true;
  actionsPlanRetrieved:boolean=true;
  indicatorsActionsPlan(uuid:any){
    this.actionsPlanRetrieved = false;
    $('.icon_click_here').delay(300).fadeIn(2000);  
    this.loadingIndicatorsPlan = true;  
    this.dashboardService.getActionsPlanIndicators(uuid).subscribe(
      ( data: any ) => {
        this.indicators = data.indicators;        
        this.actionsPlanRetrieved=false;
        setTimeout(()=>{
          this.loadingIndicatorsPlan = false; 
        }, 1000);
        // Get all buttons with class="btn" inside the container
      setTimeout(()=>{
        $('.icon_click_here').delay(300).fadeOut(2000);
      }, 2000);
    },(error) => {
        console.error('There was an error!', error);
        this.loadingIndicatorsPlan = false; 
      });
  } 
  selectAction(action:any){
    this.selectedAction =null;
    this.selectedAction = this.action.find((d:any) => d.action_uuid== action);
    if(this.selectedAction)
    this.updateActionForm.patchValue({
      description:this.selectedAction.action_description?this.selectedAction.action_description:'---',
      status:this.getStatus(this.selectedAction.action_status)
    })
  }
  getStatus(status: string): string {
    switch (status) {
      case 'Non fait':
        return '38515baefec364fd3d5cf3efb177fa79';
      case 'En cours':
        return '35377d896b4b5dfbe7e5cd804a58ecdb';
      case 'Fait':
        return 'done';
    
      default:
        return '';
    }
  }
  canceledActions:any[]=[];
  allActions:any[]=[];
  canceledActionsShowed:boolean=false;
  show_action_canceled_visits(showOrNot:boolean){
    if(showOrNot){
      this.canceledActionsShowed = true;
      this.action = this.canceledActions;
    }else {
      this.canceledActionsShowed = false;
      this.action = this.allActions;
    }
   
    (<any>$('#alter_paginations')).DataTable().clear().destroy();
        setTimeout(()=>{
            (<any>$("#alter_paginations")).DataTable( {
              "pagingType": "full_numbers",
              "scrollX": '400px',
              "iDisplayLength": 25,
              "aaSorting": [],
              columnDefs: [ { type: 'date', 'targets': [4], "orderable": true } ],
              "scrollCollapse": false,
              "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "sInfo": "",
                "sInfoEmpty": "",
                searchPlaceholder: "Saisir un mot clé",
                "sInfoFiltered": "",
                "sInfoPostFix": "",
                "sSearch": "Rechercher:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                  "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                },
                "oAria": {
                  "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
              },
              drawCallback: function () {
                (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
              }
          });
        }, 300);
  }
  Actions(){
    if(this.role=='cmrc'){
      var token = null;
      if(localStorage.getItem("token")!=undefined) {
        token =localStorage.getItem("token");
      }else if(sessionStorage.getItem("token")!=undefined){
        token =sessionStorage.getItem("token");
      }
      let decodedJWT = JSON.parse(window.atob(token!.split('.')[1]));
      this.visitServiceservice.getActions(decodedJWT.userId);
    }else {
      this.visitServiceservice.getActions("all");
    }
    this.visitServiceservice.actionsSubject.subscribe(
      ( data: any ) => {
        if(data.code =="b8f8289ade38c75780d8156c9d8fd624"){
          this.action = data.actions.sort((a:any, b:any) => new Date(b.action_added_at).getTime() - new Date(a.action_added_at).getTime());
          this.allActions = data.actions.sort((a:any, b:any) => new Date(b.action_added_at).getTime() - new Date(a.action_added_at).getTime());
          this.canceledActions = data.actionsCanceled.sort((a:any, b:any) => new Date(b.action_added_at).getTime() - new Date(a.action_added_at).getTime());
          this.getAllCustomers();
          this.getCommercials();
          this.getSectors();
          this.Topic();
          this.getCities(); 
        }
        this.loading_actions = false;
        (<any>$('#alter_paginations')).DataTable().clear().destroy();
        setTimeout(()=>{
            (<any>$("#alter_paginations")).DataTable( {
              "pagingType": "full_numbers",
              "scrollX": '400px',
              "iDisplayLength": 25,
              "aaSorting": [],
              columnDefs: [ { type: 'date', 'targets': [4], "orderable": true } ],
              "scrollCollapse": false,
              "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "sInfo": "",
                "sInfoEmpty": "",
                searchPlaceholder: "Saisir un mot clé",
                "sInfoFiltered": "",
                "sInfoPostFix": "",
                "sSearch": "Rechercher:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                  "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                },
                "oAria": {
                  "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
              },
              drawCallback: function () {
                (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
              }
          });
        }, 300);
      },
      )  
    }
  successUpdateAction:boolean=false;
  failedUpdateAction:boolean=false;
  loaderUpdateAction:boolean=false;
  updateActionStatusSubscription!: Subscription;

  areAllControlsEmpty(): boolean {
    const controls = this.advancedSearchForm.controls;   
    return Object.keys(controls).every(controlName => controls[controlName].value === '');
  }
  
  resetForm(){
    this.updateActionForm.reset();
  }
  updateActionStatus(){
    this.loaderUpdateAction = true;
    let formValue = this.updateActionForm.value;
    this.updateActionStatusSubscription = this.visitService.updateStatusAction(formValue.status,formValue.motif,this.selectedAction.action_uuid,this.selectedAction.visit).subscribe(
      ( data: any ) => {
        if(data.code=="5f116e45b722b38a15b57085f5705011"){
          (<any>$('#alter_paginations')).DataTable().destroy();
          this.Actions();
          this.successUpdateAction = true;
          this.failedUpdateAction = false;
          
          $("#status_action_updated").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          this.loaderUpdateAction=false;
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#status_action_updated").hide();
            $("#updateAction").click();
          }, 8000);
        }else {
          this.loaderUpdateAction=false;
          this.successUpdateAction = false;
          this.failedUpdateAction = true;
          $("#status_action_not_updated").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#status_action_not_updated").hide();
          }, 8000);
        }
      },
      (err: any) => {
        console.log(err);
        this.loaderUpdateAction=false
        
      }
    )  
  }
  updateStatus(newStatus:any,visit:any){
    this.visitService.updateStatusActionw(newStatus,this.selectedAction.action_uuid,visit);
    this.visitService.actionsStatusSubject.subscribe(
      ( data: any ) => {
        if(data.code=="5f116e45b722b38a15b57085f5705011"){
          (<any>$('#alter_paginations')).DataTable().destroy();
          this.Actions();
          this.successUpdateAction=true;
          this.failedUpdateAction = false;
          
          $("#status_action_updated").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#status_action_updated").hide();
          }, 8000);
        }else {
          this.successUpdateAction=false;
          this.failedUpdateAction = true;
          $("#status_action_not_updated").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#status_action_not_updated").hide();
          }, 8000);
        }
      },
    )  
  }

  pdfOrUpdateLoading:boolean = false;
  Pdf(id_visit:any){
    this.dashboardService.getPdf(id_visit);
    this.dashboardService.pdfSubject.subscribe(
      ( data: any ) => {
        if(data.code =="f3030809fbd166bcc94653d58a6e6a47"){
          const source = `data:application/pdf;base64,`+data.report;
          const link = document.createElement("a");
          link.href = source;
          link.download = data.report_filename;
          link.click();
        }
      },)
  }

  refClients:any[] =[];
  getAllCustomers(){
    var glob=this;
    this.customersService.getAllCustomers();
    this.customersService.customersSubject.subscribe(
      ( data: any ) => {
        if(data.code=="a12d89f623abb138ebacc91b3703326a" && data.customers !=null){
          var newArrayAllCustomers:any[] = [];
          for(let cust of data.customers){
            var sites:any[]=[];
            var site:any = {
              city:cust.customer_city,
              uuid:cust.city,
              customer:cust.customer
            }
            sites.push(site)
            var customer = {
              rs_customer:cust.customer_rs,
              city_uuid:cust.customer_city,
              uuid:cust.customer,
              sites:sites
            }
            newArrayAllCustomers.push(customer);
          }
          setTimeout(()=>{
            this.refClients = newArrayAllCustomers;
            (<any>$( "#customers" )).autocomplete({
              source: function ( request:any, response:any ) {
                response($.map(glob.refClients, function (obj, key) {
                  var name = obj.rs_customer.toUpperCase();
                  if (name.indexOf(request.term.toUpperCase()) != -1) {				
                    return {
                      label: obj.rs_customer,
                      value: obj.uuid // Value
                    }
                  } else {
                    return null;
                  }
                }));			
              },    
              focus: function(event:any, ui:any) {
                event.preventDefault();
              },
              // Once a value in the drop down list is selected, do the following:
              select: function(event:any, ui:any) {
                      event.preventDefault();
                // place the person.given_name value into the textfield called 'select_origin'...
                glob.advancedSearchForm.controls['customer'].setValue(ui.item.value);             
                $('#customers').val(ui.item.label);
                // ... any other tasks (like setting Hidden Fields) go here...
              }
            });
          }, 1000);
        }
        
      },
    )  
  }
  ourTeam:any[]=[]
  getCommercials(){
    var glob=this;
    this.visitService.getCommercialsToAffect();
    this.visitService.commercialsSubject.subscribe(
      ( data: any ) => {
        if(data.code=="b1f37eec383fcada527079602ac178b3"){          
          this.ourTeam = data.commercials;
          (<any>$( "#commercials" )).autocomplete({
            source: function ( request:any, response:any ) {
              response($.map(glob.ourTeam, function (obj, key) {
                var name = obj.commercial.toUpperCase();
                if (name.indexOf(request.term.toUpperCase()) != -1) {				
                  return {
                    label: obj.commercial,
                    value: obj.commercial_uuid // Value
                  }
                } else {
                  return null;
                }
              }));			
            },    
            focus: function(event:any, ui:any) {
              event.preventDefault();
            },
            // Once a value in the drop down list is selected, do the following:
            select: function(event:any, ui:any) {
                    event.preventDefault();
              // place the person.given_name value into the textfield called 'select_origin'...
              glob.advancedSearchForm.controls['commercial'].setValue(ui.item.value);
              $('#commercials').val(ui.item.label);
              // ... any other tasks (like setting Hidden Fields) go here...
            }
          });
        }
      },
    )  
  }
  refSectors:any[]=[];
  getSectors(){
    var glob=this;
    this.msSector.getSectors(this.msToken);
    this.msSector.sectorsSubject.subscribe(
      ( data: any ) => {
        if(data.status=="200 OK"){
          this.refSectors = data.sectors;
          (<any>$( "#sectors" )).autocomplete({
            source: function ( request:any, response:any ) {
              response($.map(glob.refSectors, function (obj, key) {
                var name = obj.label.toUpperCase();
                if (name.indexOf(request.term.toUpperCase()) != -1) {				
                  return {
                    label: obj.label,
                    value: obj.id // Value
                  }
                } else {
                  return null;
                }
              }));			
            },    
            focus: function(event:any, ui:any) {
              event.preventDefault();
            },
            // Once a value in the drop down list is selected, do the following:
            select: function(event:any, ui:any) {
                    event.preventDefault();
              // place the person.given_name value into the textfield called 'select_origin'...
              glob.advancedSearchForm.controls['customer_sector'].setValue(ui.item.value);
              $('#sectors').val(ui.item.label);
              // ... any other tasks (like setting Hidden Fields) go here...
            }
          });
        }
      },
    )  
  }
  // getjSectors(){
  //   var glob=this;
  //   this.visitService.getSectors();
  //   this.visitService.sectorsSubject.subscribe(
  //     ( data: any ) => {
  //       if(data.code=="d9cc2e7dc2cf71242be86ab1ad241752"){
  //         this.refSectors = data.sectors;
  //         (<any>$( "#sectors" )).autocomplete({
  //           source: function ( request:any, response:any ) {
  //             response($.map(glob.refSectors, function (obj, key) {
  //               var name = obj.sector.toUpperCase();
  //               if (name.indexOf(request.term.toUpperCase()) != -1) {				
  //                 return {
  //                   label: obj.sector,
  //                   value: obj.uuid // Value
  //                 }
  //               } else {
  //                 return null;
  //               }
  //             }));			
  //           },    
  //           focus: function(event:any, ui:any) {
  //             event.preventDefault();
  //           },
  //           // Once a value in the drop down list is selected, do the following:
  //           select: function(event:any, ui:any) {
  //                   event.preventDefault();
  //             // place the person.given_name value into the textfield called 'select_origin'...
  //             glob.advancedSearchForm.controls['customer_sector'].setValue(ui.item.value);
  //             $('#sectors').val(ui.item.label);
  //             // ... any other tasks (like setting Hidden Fields) go here...
  //           }
  //         });
  //       }
  //     },
  //   )  
  // }
  topics:any;
  Topic(){
    var glob=this;
    this.visitService.getTopic();
    this.visitService.topicSubject.subscribe(
      ( data: any ) => {
        if(data.code=="d9cc2e7dc2cf71242be86ab1ad241752"){          
          this.topics = data.topics;
          (<any>$( "#topics" )).autocomplete({
            source: function ( request:any, response:any ) {
              response($.map(glob.topics, function (obj, key) {
                var name = obj.topic.toUpperCase();
                if (name.indexOf(request.term.toUpperCase()) != -1) {				
                  return {
                    label: obj.topic,
                    value: obj.uuid // Value
                  }
                } else {
                  return null;
                }
              }));			
            },    
            focus: function(event:any, ui:any) {
              event.preventDefault();
            },
            // Once a value in the drop down list is selected, do the following:
            select: function(event:any, ui:any) {
                    event.preventDefault();
              // place the person.given_name value into the textfield called 'select_origin'...
              glob.advancedSearchForm.controls['visit_topic'].setValue(ui.item.value);
              $('#topics').val(ui.item.label);
              // ... any other tasks (like setting Hidden Fields) go here...
            }
          });
        }
      },
    )  
  }
  refCities:any[]=[];
  getCities(){
    var glob=this;
    this.customersService.getRefCities();
    this.customersService.refCitiesSubject.subscribe(
      ( data: any ) => {
        if(data.code=="9d0907561104ccc6b9d188f036bd358c"){
          this.refCities = data.cities;
          (<any>$( "#cities" )).autocomplete({
            source: function ( request:any, response:any ) {
              response($.map(glob.refCities, function (obj, key) {
                var name = obj.city.toUpperCase();
                if (name.indexOf(request.term.toUpperCase()) != -1) {				
                  return {
                    label: obj.city,
                    value: obj.uuid // Value
                  }
                } else {
                  return null;
                }
              }));			
            },    
            focus: function(event:any, ui:any) {
              event.preventDefault();
            },
            // Once a value in the drop down list is selected, do the following:
            select: function(event:any, ui:any) {
                    event.preventDefault();
              // place the person.given_name value into the textfield called 'select_origin'...
              glob.advancedSearchForm.controls['customer_city'].setValue(ui.item.value);             
              $('#cities').val(ui.item.label);
              // ... any other tasks (like setting Hidden Fields) go here...
            }
          });
          // (<any>$( "#cities" )).autocomplete({
          //   source: function ( request:any, response:any ) {
          //     response($.map(glob.refCities, function (obj, key) {
          //       var name = obj.city.toUpperCase();
          //       if (name.indexOf(request.term.toUpperCase()) != -1) {				
          //         return {
          //           label: obj.city,
          //           value: obj.uuid // Value
          //         }
          //       } else {
          //         return null;
          //       }
          //     }));			
          //   },    
          //   focus: function(event:any, ui:any) {
          //     event.preventDefault();
          //   },
          //   // Once a value in the drop down list is selected, do the following:
          //   select: function(event:any, ui:any) {
          //           event.preventDefault();
          //     // place the person.given_name value into the textfield called 'select_origin'...
          //     glob.advancedSearchForm.controls['customer_city'].setValue(ui.item.value);
          //     $('#cities').val(ui.item.label);
          //     // ... any other tasks (like setting Hidden Fields) go here...
          //   }
          // });
        }
      },
    )  
  }
  onKeyUp(event:any,input:any) { // appending the updated value to the variable
    if(event.target.value.length==0) {
      this.advancedSearchForm.controls[input].setValue("");
    }
  }

  isValidUUID(uuid: string): boolean {
    const uuidPattern = /^[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
    return uuidPattern.test(uuid);
  }
  advancedSearchRequest:any={};
  search(){
    ($('.collapse.show')as any).collapse('hide');
    let customerUUID = this.advancedSearchForm.value.customer;
    if (!this.isValidUUID(customerUUID) && customerUUID!=="") {
      const matchingCustomer = this.refClients.find(client => client.rs_customer && client.rs_customer.toUpperCase().includes(customerUUID.toUpperCase()));
      if (matchingCustomer) {
        customerUUID = matchingCustomer.uuid;
      }
    }
    this.advancedSearchForm.value.customer = customerUUID;

    let commercialUUID = this.advancedSearchForm.value.commercial; 
    if (!this.isValidUUID(commercialUUID) && commercialUUID!=="") {
      const matchingCommercial = this.ourTeam.find(teamMember => teamMember.commercial && teamMember.commercial.toUpperCase().includes(commercialUUID.toUpperCase()));
      if (matchingCommercial) {
        commercialUUID = matchingCommercial.commercial_uuid;
      }
    }
    this.advancedSearchForm.value.commercial = commercialUUID;

    let sectorUUID = this.advancedSearchForm.value.customer_sector;
    if (!this.isValidUUID(sectorUUID) && sectorUUID!=="") {
      const matchingSector = this.refSectors.find(sector => sector.sector && sector.sector.toUpperCase().includes(sectorUUID.toUpperCase()));
      if (matchingSector) {
        sectorUUID = matchingSector.uuid;
      }
    }
    this.advancedSearchForm.value.customer_sector = sectorUUID;

    let topicUUID =this.advancedSearchForm.value.visit_topic;
    if (!this.isValidUUID(topicUUID) && topicUUID!=="") {
      const matchingTopic = this.topics.find((topic:any) => topic.topic && topic.topic.toUpperCase().includes(topicUUID.toUpperCase()));
      if (matchingTopic) {
        topicUUID = matchingTopic.uuid;
      }
    }
    this.advancedSearchForm.value.visit_topic = topicUUID;

    let cityUUID = this.advancedSearchForm.value.customer_city;
    if (!this.isValidUUID(cityUUID) && cityUUID!=="") {
      const matchingCity = this.refCities.find(city => city.city &&city.city.toUpperCase().includes(cityUUID.toUpperCase()));
      if (matchingCity) {
        cityUUID = matchingCity.uuid;
      }
    }
    this.advancedSearchForm.value.customer_city = cityUUID;
    if ($("#roundedChk2").is(':checked')) {
      $("#roundedChk2").attr('value', 'true');
    } else {
      $("#roundedChk2").attr('value', 'false');
    }
    var archivedFilter = $("#roundedChk2").val();
    this.advancedSearchForm.value.archived =archivedFilter;
    
    this.visitServiceservice.advancedSearchRequest = this.advancedSearchForm.value;    
    if(this.advancedSearchForm.value.customer=="" && this.advancedSearchForm.value.commercial=="" &&
      this.advancedSearchForm.value.customer_sector=="" && this.advancedSearchForm.value.visit_topic=="" &&
      this.advancedSearchForm.value.customer_city=="" && this.advancedSearchForm.value.action_type=="" && 
      this.advancedSearchForm.value.action_status=="" && this.advancedSearchForm.value.visit_action_status=="" && 
      (this.advancedSearchForm.value.start_date=="" || this.advancedSearchForm.value.end_date=="" ) && 
      this.advancedSearchForm.value.archived == false
      ){
      this.Actions();
    }else {      
      this.loading_actions_search = true;
      this.visitServiceservice.advancedSearchActions();
      this.advancedSearchRequest=this.visitServiceservice.advancedSearchSubject.subscribe(
        ( data: any ) => {
          this.loading_actions_search = false;
          if(data.code=="1527e54c0527e855e479163e5e3c0477"){
            this.action = data.actions.sort((a:any, b:any) => new Date(b.action_added_at).getTime() - new Date(a.action_added_at).getTime());
            (<any>$('#alter_paginations')).DataTable().clear().destroy();
            setTimeout(()=>{
              (<any>$("#alter_paginations")).DataTable( {
                  "pagingType": "full_numbers",
                  "scrollX": '400px',
                  "aaSorting": [],
                  "iDisplayLength": 25,
                  columnDefs: [ { type: 'date', 'targets': [4], "orderable": true } ],
                  "scrollCollapse": false,
                  "language": {
                    "sProcessing": "Traitement en cours ...",
                    "sLengthMenu": "Afficher _MENU_ lignes",
                    "sZeroRecords": "Aucun résultat trouvé",
                    "sEmptyTable": "Aucune donnée disponible",
                    "sInfo": "",
                    "sInfoEmpty": "",
                    searchPlaceholder: "Saisir un mot clé",
                    "sInfoFiltered": "",
                    "sInfoPostFix": "",
                    "sSearch": "Rechercher:",
                    "sUrl": "",
                    "sInfoThousands": ",",
                    "sLoadingRecords": "Chargement...",
                    "oPaginate": {
                      "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                    },
                    "oAria": {
                      "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                    }
                  },
                  drawCallback: function () {
                    (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                          type: 'line',
                          width: '60',
                          height: '20',
                          lineColor: '#1a73e9',
                          fillColor: '#c2d5ff',
                          spotColor: 'transparent',
                          minSpotColor: 'transparent',
                          maxSpotColor: 'transparent',
                          highlightSpotColor: 'transparent',
                          highlightLineColor: 'transparent',
                      });
                  }
              });
            }, 500);
          }
        },
      )
    }
    this.getAllCustomers();
    this.getCommercials();
    this.getSectors();
    this.Topic();
    this.getCities(); 
  }

  selectedCustomer:any=null;
  retrieveCustomerSubscription!:Subscription;
  retrieveCustomerLoder:boolean = false;
  retrieveCustomer(customer:any){
    this.retrieveCustomerLoder = true;
    this.selectedCustomer = null;
    this.retrieveCustomerSubscription=this.customersService.retrieveCustomer(customer).subscribe(
      (data:any) => {
        if (data.code == "91cb649c3775dae97f5a003ced0791b9"){
          this.selectedCustomer = data.customer;
        }
        this.retrieveCustomerLoder = false;
      },
      (error: any) => {
        console.log(error);
        this.retrieveCustomerLoder = false;        
      }
    );
    this.getConversationAboutCustomer(customer);
  }

  loadingMessages:boolean=false;
  messages:any[]=[];
  getConversationAboutCustomer(customerUuid:string){
    this.messages = [];
    this.loadingMessages=true;
    this.customersService.getCustomerConversation(customerUuid).subscribe(
      ( data: any ) => {
        if(data.code=="a06f376e86f9c47135aee1d1bac7b3e3") {
          this.messages = data.messagesVisit;
          $(".chat-messages").animate({ scrollBottom: $(".chat-messages")[0]?.scrollHeight }, 200)
        }
        this.loadingMessages=false;
      },
      error => {
        console.error('There was an error!', error);
      }
    )
  }
  sendNewMessage(customerUuid:string){
    var message = $('#messageText').val();
    var myImage = null;
    var myavatar = this.messages.find((d:any) => d.sender== "me");
    if(myavatar!=undefined && myavatar!=null){
      myImage = myavatar.sender_avatar;
    }else {
      myImage = null;
    }            
    if(message != null && message != ""){
      var newMessage = {
        message:message,
        sent_at:new Date(),
        sender:"me",
        sender_avatar:myImage,
        important:$("#roundedChk2").is(':checked')
      }
      var requestBody = {
        message:message,
        important:$("#roundedChk2").is(':checked')
      }
      this.customersService.sendMessage(customerUuid, requestBody).subscribe(
        ( data: any ) => {
          if(data.code=="2ea8e5510c04f55b90c85304f9f59532") {
            $('#messageText').val("");
            this.messages.push(newMessage);
            // $(".chat-messages").animate({scrollTop:$(".chat-messages")[0].scrollHeight})
            $(".chat-messages").animate({ scrollTop: $(".chat-messages")[0].scrollHeight }, 500)
            $(".chat-messages").animate({ scrollBottom: $(".chat-messages")[0].scrollHeight }, 200)
          }
          this.loadingMessages=false;
        },
        (error:any) => {
          console.error('There was an error!', error);
        }
      );
    }
    
  }

  ngOnDestroy(){
    this.updateActionStatusSubscription?.unsubscribe();
    this.retrieveCustomerSubscription?.unsubscribe();
  }
}
